export const ka = {
  title: 'Landsat-8 / Sentinel-2 Satellite Imagery',
  content: [
    {
      label: 'ფუნქცია',
      value:
        'მაღალი რეზოლუციის სატელიტური გამოსახულება აუცილებელია GFW-ზე არსებული სხვა მონაცემთა ფენების კონტექსტის უზრუნველსაყოფად, როგორიცაა ხეების საფარის ცვლილების დრაივერების ინტერპრეტაცია. ის ჩვეულებრივ გამოიყენება ტყეების გაჩეხვის შესახებ სიგნალიზაციის შესაძლო მიზეზების დასადგენად. გამოსახულება ასევე შეიძლება გამოყენებულ იქნას ვალიდაციის პროტოკოლებში, მიწის/ტყის საფარის სიზუსტის შესაფასებლად და პროდუქტების შესაცვლელად.',
    },
    {
      label: 'რეზოლუცია',
      value: 'Sentinal-2: 10 x 10 მეტრი, Landsat 8: 30 x 30 მეტრი',
    },
    {
      label: 'გეოგრაფიული გაშუქება',
      value: 'გლობალური',
    },
    {
      label: 'წყარო',
      value:
        'კოპერნიკი სენტინელი-2. ამოღებულია Google Earth Engine-დან. მონაცემები დამუშავებულია ევროპის კოსმოსური სააგენტოს (ESA) მიერ.',
    },
    {
      label: 'სიხშირე',
      value:
        'ახალი სურათები ყოველდღიურად ხდება ხელმისაწვდომი. სურათის გადახედვის დრო: Sentinel-2A: ყოველ 10 დღეში, Landsat 8: ყოველ 16 დღეში',
    },
    {
      label: 'შინაარსის თარიღი',
      value: '2012 წლის იანვარი - პრეს.',
    },
  ],
  overview: {
    label: 'მიმოხილვა',
    value:
      'ეს მონაცემები აჩვენებს უახლეს სატელიტურ სურათებს, რომლებიც აკმაყოფილებს ღრუბლის საფარის შერჩეულ კრიტერიუმებს Sentinel-2 და Landsat 8 სისტემებიდან. . Sentinel-2, რომელსაც მართავს ევროპის კოსმოსური სააგენტო, აქვს გლობალური დაფარვა 10 მეტრიანი გარჩევადობით და შეუძლია განახლებული სურათების მიღება ყოველ 10 დღეში. Landsat 8, რომელსაც მართავს აშშ-ის გეოლოგიური სამსახური, ასევე არის გლობალური თანამგზავრი და შეუძლია მიიღოს განახლებული გამოსახულება, 30 მეტრიანი გარჩევადობით, ყოველ 16 დღეში. გამოსახულება, რომელიც ასახავს ბუნებრივ ფერს და მცენარეულობას, ხელმისაწვდომია ორივე თანამგზავრიდან. ბუნებრივი ფერის გამოსახულებები იყენებს ინფორმაციას ხილული შუქისგან (წითელი, მწვანე და ლურჯი), რათა აჩვენონ დედამიწის ზედაპირი ისე, როგორც ეს ადამიანის თვალს ეჩვენება. მცენარეული სიჯანსაღე გამოვლენილია ნორმალიზებული განსხვავების მცენარეულობის ინდექსის (NDVI) გამოყენებით, რომელიც აერთიანებს ინფორმაციას როგორც წითელ, ასევე ინფრაწითელ მახლობლად ასახვის შესახებ. ეს მეთოდი ეყრდნობა იმ ფაქტს, რომ ჯანსაღი მცენარეულობა შთანთქავს ყველაზე ხილულ შუქს და ასახავს ყველაზე ახლო ინფრაწითელ შუქს, რომელიც ეცემა მის ზედაპირს. გამოსახულების ინტერპრეტაციისას, რომელიც აჩვენებს მცენარეულობის ჯანმრთელობას, წითელი მიუთითებს ჯანსაღ მზარდ მცენარეულობაზე, მწვანე მიუთითებს შიშველ მიწაზე და შავი მიუთითებს წყლის ობიექტებზე.',
  },
};
